import { Paper, styled, Typography, Modal, Box } from '@mui/material';
import Fade from '@mui/material/Fade';
import CrossIcon from '../assets/icons/cross-icon';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  boxShadow: 24,
  maxHeight: 500,
  overflow: 'scroll',
};

const ModalWrapper = styled(Paper)(({ theme }) => ({
  border: '2px solid',
  borderColor: theme.palette.primary.main,
  textAlign: 'center',
}));

const TermsText = styled(Typography)(() => ({
  textAlign: 'justify',
  margin: '.7rem 0',
}));

interface TermsProps {
  openModal: boolean;
  setOpenModal: (v: boolean) => void;
}

export default function TermsModal(props: TermsProps) {
  const { openModal, setOpenModal } = props;

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openModal}
        onClose={() => setOpenModal(!openModal)}
        closeAfterTransition
      >
        <Fade in={openModal}>
          <ModalWrapper sx={style}>
            <Box
              sx={{
                position: 'sticky',
                top: 0,
                backgroundColor: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '1rem 1rem',
                borderBottom: '1px solid',
                borderColor: 'lightgrey',
              }}
            >
              <Typography
                variant="h2"
                sx={{
                  fontSize: '0.9rem',
                  textAlign: 'left',
                }}
              >
                <strong>Términos & Condiciones: Boleta por Mail</strong>
              </Typography>

              <Box
                sx={{
                  cursor: 'pointer',
                  display: 'flex',
                }}
                onClick={() => setOpenModal(!openModal)}
              >
                <CrossIcon />
              </Box>
            </Box>
            <Box sx={{ padding: '0 1rem' }}>
              <TermsText>
                <strong>VISTO:</strong>
              </TermsText>
              <TermsText>
                La Ley Nacional N° 25.326 y su Decreto Reglamentario Nº
                1558/2001, la Ley Nacional N° 25.506, la Ley Provincial N°
                13.666, la Ordenanza Municipal N° 44/17 y su Decreto
                Promulgatorio N° 2.484/17.
              </TermsText>
              <TermsText>
                <strong>CONSIDERANDO:</strong>
              </TermsText>
              <TermsText>
                Que por Ley Nacional N° 25.326 se establecen los principios
                generales relativos a la protección de datos y derechos de
                titulares y usuarios responsables de archivos, registros y banco
                de datos, y que, a través del Decreto Reglamentario Nº 1556/2001
                se reglamenta la misma. Que por Ley Nacional N° 25.506 se
                reconoce el empleo de la firma electrónica y de la firma digital
                y su eficacia jurídica Firma Digital. Que por medio de la Ley
                Provincial N° 13.666 la Provincia de Buenos Aires se adhirió a
                lo dispuesto en la norma nacional. Que mediante la sanción de la
                Ordenanza N° 44/17 y el correspondiente Decreto Promulgatorio N°
                2.484/17, el Municipio de San Miguel realizó su adhesión a la
                Ley Provincial mencionada ut supra con respecto a la Firma
                Digital. Que a fin de alcanzar una gestión pública de calidad
                que posibilite la provisión eficaz y eficiente de bienes y
                servicios públicos a los ciudadanos del Municipio de San Miguel
                de manera equitativa, transparente y efectiva, para una mayor
                integración y desarrollo de la sociedad se implementó a través
                del Decreto N° 2.737/17 el “Sistema de Gestión Documental
                Electrónica (GDE)” en el ámbito municipal. Que en virtud del
                estado de implementación de sistemas de gestión y tramitación
                digital, entre ellos el portal de Autogestión del Ciudadano,
                resulta oportuno el dictado del acto administrativo por el cual
                se haga explícito el tratamiento de datos personales de los
                ciudadanos e interesados partícipes de procedimientos con la
                administración municipal. Que el derecho a la protección de los
                datos personales no es un derecho absoluto sino que debe
                considerarse en relación con su función en la sociedad y
                mantener el equilibrio con otros derechos fundamentales,
                resultando necesario reglamentar en función de los avances
                tecnológicos y nuevas formas de tramitación. Que la protección
                de los derechos y libertades de las personas físicas con
                respecto al tratamiento de datos personales exige la adopción de
                medidas técnicas y organizativas apropiadas con el fin de
                garantizar el cumplimiento de los requisitos de la normativa
                nacional vigente.
              </TermsText>
              <TermsText>
                Por ello, EL SEÑOR INTENDENTE MUNICIPAL DE SAN MIGUEL DECRETA:
              </TermsText>
              <TermsText>
                ARTÍCULO 1°. Apruébese el reglamento de protección de datos
                personales que como Anexo I integra el presente decreto. El cual
                entrará en vigencia en el transcurso del ejercicio 2023.
              </TermsText>
              <TermsText>
                ARTÍCULO 2°: Regístrese, comunique y publíquese para
                conocimiento y cumplimiento la presente resolución y reglamento.
              </TermsText>
              <TermsText>
                Anexo I - REGLAMENTO DE PROTECCIÓN DE DATOS PERSONALES
                Municipalidad de San Miguel Provincia de Buenos Aires
              </TermsText>
              <TermsText>
                <strong>Objeto</strong>
              </TermsText>
              <TermsText>
                El presente Reglamento establece los lineamientos relativos a la
                protección de las personas físicas en lo que respecta al
                tratamiento de los datos personales a fines de tramitación
                dentro de la Administración de la Municipalidad de San Miguel,
                en concordancia con la normativa Nacional y Provincial vigente.
              </TermsText>
              <TermsText>
                <strong>Definiciones</strong>
              </TermsText>
              <TermsText>
                A efectos del presente Reglamento se entenderá por: 1) «datos
                personales»: toda información sobre una persona física
                identificada o identificable («el interesado»); se considerará
                persona física identificable toda persona cuya identidad pueda
                determinarse, directa o indirectamente, en particular mediante
                un identificador, como por ejemplo un nombre, un número de
                identificación, datos de localización, un identificador en línea
                o uno o varios elementos propios de la identidad física,
                fisiológica, genética, psíquica, económica, cultural o social de
                dicha persona; 2) «tratamiento»: cualquier operación o conjunto
                de operaciones realizadas sobre datos personales o conjuntos de
                datos personales, ya sea por procedimientos automatizados o no,
                como la recogida, registro, organización, estructuración,
                conservación, adaptación o modificación, extracción, consulta,
                utilización, comunicación por transmisión, difusión o cualquier
                otra forma de habilitación de acceso, cotejo o interconexión,
                limitación, supresión o destrucción; 3) «limitación del
                tratamiento»: el marcado de los datos de carácter personal
                conservados con el fin de limitar su tratamiento en el futuro;
                4) «elaboración de perfiles»: toda forma de tratamiento
                automatizado de datos personales consistente en utilizar datos
                personales para evaluar determinados aspectos personales de una
                persona física, en particular para analizar o predecir aspectos
                relativos al rendimiento profesional, situación económica,
                salud, preferencias personales, intereses, fiabilidad,
                comportamiento, ubicación o movimientos de dicha persona física;
                5) «fichero»: todo conjunto estructurado de datos personales,
                accesibles con arreglo a criterios determinados, ya sea
                centralizado, descentralizado o repartido de forma funcional o
                geográfica; 6) «encargado del tratamiento» o «encargado»: la
                persona física o jurídica, autoridad pública, servicio u otro
                organismo que trate datos personales por cuenta del responsable
                del tratamiento; 7) «consentimiento del interesado»: toda
                manifestación de voluntad libre, específica, informada e
                inequívoca por la que el interesado acepta, ya sea mediante una
                declaración o una clara acción afirmativa, el tratamiento de
                datos personales que le conciernen.
              </TermsText>
              <TermsText>
                <strong>Ámbito de aplicación material</strong>
              </TermsText>
              <TermsText>
                El presente Reglamento se aplica al tratamiento total o
                parcialmente automatizado de datos personales, así como al
                tratamiento no automatizado de datos personales contenidos o
                destinados a ser incluidos en un fichero. El presente Reglamento
                no se aplica al tratamiento de datos personales efectuado por
                una persona física en el ejercicio de actividades exclusivamente
                personales o domésticas; Por parte de las autoridades
                competentes con fines de prevención, investigación, detección o
                enjuiciamiento de infracciones penales, o de ejecución de
                sanciones penales, incluida la de protección frente a amenazas a
                la seguridad pública y su prevención
              </TermsText>
              <TermsText>
                <strong>Ámbito de Aplicación territorial</strong>
              </TermsText>
              <TermsText>
                El presente Reglamento se aplica al tratamiento de datos
                personales en el contexto de las actividades de un
                establecimiento del responsable o del encargado en el ámbito de
                la Municipalidad de San Miguel, Provincia de Buenos Aires, y en
                concordancia con la normativa nacional y provincial vigente.
              </TermsText>
              <TermsText>
                <strong>Alcance</strong>
              </TermsText>
              <TermsText>
                El presente reglamento alcanza la protección de datos personales
                suministrados a la Municipalidad en el contexto de tramitación o
                intercambio a efectos administrativos. El presente reglamento
                aplica a su vez al domicilio electrónico constituído e informado
                a la Municipalidad con fines de recepción de notificaciones y
                tasas. Todo tratamiento de datos personales en el contexto de
                las actividades desarrolladas con la Municipalidad debe llevarse
                a cabo de conformidad con el presente Reglamento. Los siguientes
                lineamientos deben aplicarse a toda la información relativa a
                una persona física y jurídica identificada o identificable.{' '}
              </TermsText>
              <TermsText>
                <strong>Consentimiento del Interesado</strong>
              </TermsText>
              <TermsText>
                Todo aquel interesado en realizar una gestión con la
                Municipalidad en la cual sea necesario proporcionar datos
                personales, deberá manifestar su consentimiento de voluntad
                libre, específica, informada, e inequívoca de aceptar el
                tratamiento de datos de carácter personal que le conciernen,
                como una declaración por escrito, inclusive por medios
                electrónicos. La Municipalidad no podrá solicitar más datos que
                los necesarios en el marco de la normativa vigente a fin de
                realizar las gestiones requeridas ni podrá compartir los datos
                suministrados con terceros ni otras entidades. El intercambio de
                datos entre jurisdicciones públicas se llevará a cabo respetando
                estrictamente las normas nacionales y reglamentaciones al
                respecto, y sólo cuando sea necesario a fin de agilizar y
                garantizar una mejor gestión al interesado en base a un interés
                legítimo. Constituye un interés legítimo del responsable el
                tratamiento de datos personales en la medida estrictamente
                necesaria y proporcionada para garantizar la seguridad de la red
                y de la información, es decir la capacidad de una red o de un
                sistema información de resistir, en un nivel determinado de
                confianza, a acontecimientos accidentales o acciones ilícitas o
                malintencionadas que comprometan la disponibilidad,
                autenticidad, integridad y confidencialidad de los datos
                personales conservados o transmitidos, y la seguridad de los
                servicios conexos ofrecidos por, o accesibles a través de, estos
                sistemas y redes, por parte de autoridades públicas. El
                tratamiento de datos personales con fines distintos de aquellos
                para los que hayan sido recogidos inicialmente sólo debe
                permitirse cuando sea compatible con los fines de su recogida
                inicial. En tal caso, no se requiere una base jurídica aparte,
                distinta de la que permitió la obtención de los datos
                personales. Si el tratamiento es necesario para el cumplimiento
                de una misión realizada en interés público o en el ejercicio de
                poderes públicos conferidos al responsable del tratamiento, el
                consentimiento otorgado inicialmente bastará para su utilización
                a estos efectos. Especial protección merecen los datos
                personales que, por su naturaleza, son particularmente
                sensibles. Debe incluirse entre tales datos personales los datos
                de carácter personal que revelen el origen racial o étnico. El
                tratamiento de fotografías no debe considerarse sistemáticamente
                tratamiento de categorías especiales de datos personales, pues
                únicamente se encuentran comprendidas en la definición de datos
                biométricos cuando el hecho de ser tratadas con medios técnicos
                específicos permita la identificación o la autenticación
                unívocas de una persona física. Asimismo, deben autorizarse
                excepciones a la prohibición de tratar categorías especiales de
                datos personales en particular el tratamiento de datos
                personales en el ámbito de la legislación laboral, la
                legislación sobre protección social, incluidas las pensiones y
                con fines de seguridad, supervisión y alerta sanitaria, la
                prevención o control de enfermedades transmisibles y otras
                amenazas graves para la salud. Tal excepción es posible para
                fines en el ámbito de la salud, incluidas la sanidad pública y
                la gestión de los servicios de asistencia sanitaria,
                especialmente con el fin de garantizar la calidad y la
                rentabilidad de los procedimientos utilizados para resolver las
                reclamaciones de prestaciones y de servicios. Debe autorizarse
                asimismo a título excepcional el tratamiento de dichos datos
                personales cuando sea necesario para la formulación, el
                ejercicio o la defensa de reclamaciones, ya sea por un
                procedimiento judicial o un procedimiento administrativo o
                extrajudicial.
              </TermsText>
              <TermsText>
                <strong>Principios relativos al tratamiento</strong>
              </TermsText>
              <TermsText>
                1. Los datos personales serán:
                <TermsText>
                  a)tratados de manera lícita, leal y transparente en relación
                  con el interesado («licitud, lealtad y transparencia»);
                </TermsText>
                <TermsText>
                  b)recogidos con fines determinados, explícitos y legítimos, y
                  no serán tratados ulteriormente de manera incompatible con
                  dichos fines;
                </TermsText>
                <TermsText>
                  c)adecuados, pertinentes y limitados a lo necesario en
                  relación con los fines para los que son tratados
                  («minimización de datos»);
                </TermsText>
                <TermsText>
                  d)exactos y, si fuera necesario, actualizados; se adoptarán
                  todas las medidas razonables para que se supriman o
                  rectifiquen sin dilación los datos personales que sean
                  inexactos con respecto a los fines para los que se tratan
                  («exactitud»);
                </TermsText>
                <TermsText>
                  e) mantenidos de forma que se permita la identificación de los
                  interesados durante no más tiempo del necesario para los fines
                  del tratamiento de los datos personales; los datos personales
                  podrán conservarse durante períodos más largos siempre que se
                  trate exclusivamente con fines de archivo en interés público;
                </TermsText>
                <TermsText>
                  f) tratados de tal manera que se garantice una seguridad
                  adecuada de los datos personales, incluida la protección
                  contra el tratamiento no autorizado o ilícito y contra su
                  pérdida, destrucción o daño accidental, mediante la aplicación
                  de medidas técnicas u organizativas apropiadas («integridad y
                  confidencialidad»).
                </TermsText>
              </TermsText>
              <TermsText>
                <strong>
                  Garantías y excepciones aplicables al tratamiento
                </strong>
              </TermsText>
              <TermsText>
                El tratamiento con fines de archivo en interés público, fines de
                investigación científica o histórica o fines estadísticos estará
                sujeto a las garantías adecuadas, con arreglo a la normativa
                nacional vigente para los derechos y las libertades de los
                interesados. Dichas garantías obligan a que se disponga de
                medidas técnicas y organizativas para garantizar el respeto de
                la información suministrada en el marco de la tramitación con la
                Municipalidad.
              </TermsText>
              <TermsText>
                <strong>Entrada en vigor y aplicación</strong>
              </TermsText>
              <TermsText>
                El presente Reglamento será obligatorio en todos sus elementos y
                directamente aplicable tras su aprobación.
              </TermsText>
            </Box>
          </ModalWrapper>
        </Fade>
      </Modal>
    </div>
  );
}
